import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import applyFluxibleContext from '@audacious/web-common/fluxible/applyFluxibleContext';
import QuestionChallenge from '../common/question-challenge';
import PasswordForm from '../common/password-form';

class ResetPassword extends PureComponent {
    constructor(props) {
        super(props);

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(password) {
        const {
            fluxibleContext: {
                service: {
                    resolveResetPassword
                },
            },
         } = this.props;

        resolveResetPassword({
            data: {
                password,
            },
        });
    }

    render() {
        return (
            <QuestionChallenge>
                <PasswordForm onSubmit={this.handleSubmit} />
            </QuestionChallenge>
        );
    }
}

ResetPassword.propTypes = {
    fluxibleContext: PropTypes.shape({
		service: PropTypes.shape({
            resolveResetPassword: PropTypes.func.isRequired,
		}),
	}).isRequired,
};

export default applyFluxibleContext(ResetPassword);
